import httpClient from './Http'

export default {
	
	// category groups
	getCategoryGroups(){
		return httpClient.get('/api/category-grouping');
	}
}


// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/api/CategoryService.js